// import { IFareCart } from '@interfaces';
import React from "react";

interface ProductDisplayCardProps {
    name: string;
    productImagePath: string;
    supplierName?: string | null;
    startLocationName: string;
    showDeleteButton?: boolean;
    onDelete?: () => void;
}

export const ItemsByProductHeader: React.FC<ProductDisplayCardProps> = ({
    name,
    productImagePath,
    supplierName,
    startLocationName,
    showDeleteButton = false,
    onDelete,
}: ProductDisplayCardProps) => {
    return (
        <div className="main">
            <div className="img">
                {productImagePath && <img src={productImagePath} alt={name} />}
            </div>
            <div className="info-container">
                <div className="name-container">
                    <p className="title">{name}</p>
                    <p className="sub-title">{supplierName}</p>
                    <span className="location">
                        <img width={13} height={16} src="/images/location_22.svg" alt="location" />
                        {startLocationName}
                    </span>
                </div>
                {showDeleteButton && onDelete && (
                    <button style={{ alignSelf: "flex-start" }} onClick={onDelete}>
                        <img src="/images/deleteSvgButton.svg" alt="delete" />
                    </button>
                )}
            </div>
        </div>
    );
};
